export default __webpack_public_path__ + "static/filewithlittlebluedust-d1aa05ad09778693056b693c52324592.png";